import { render, staticRenderFns } from "./ReportsTabs.vue?vue&type=template&id=504eb6f0&"
import script from "./ReportsTabs.vue?vue&type=script&lang=ts&"
export * from "./ReportsTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports